// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#erxes-messenger-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 2147483647;
}

#erxes-messenger-iframe {
  position: absolute !important;
  border: none;
  z-index: 2147483647;
  height: 100%;
  width: 100%;
  border-radius: 1rem;
}

.erxes-launcher {
  position: absolute;
  right: 12px;
  bottom: 12px;
  border: none;
  z-index: 2147483649;
  overflow: hidden;
  height: 76px;
  width: 76px;
  opacity: 0;
  transition: opacity 0.3s;
}

.erxes-messenger-hidden {
  position: fixed;
  height: min(720px, 100% - 104px);
  min-height: 80px;
  width: 408px;
  max-height: 720px;
  border-radius: 1rem;
  right: 16px;
  bottom: 92px;
  transform-origin: right bottom;
  transition:
    width 200ms ease 0s,
    height 200ms ease 0s,
    max-height 200ms ease 0s,
    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s,
    opacity 83ms ease-out 0s;
  transform: scale(0);
  opacity: 0;
  pointer-events: none;
}

.erxes-messenger-shown {
  position: fixed;
  height: min(660px, 100% - 100px);
  min-height: 80px;
  /* 400px width of messenger + scrollbar width */
  width: 408px;
  max-height: 660px;
  border-radius: 1rem;
  right: 16px;
  bottom: 92px;
  transform-origin: right bottom;
  box-shadow: 0 2px 8px 1px rgba(0, 0, 0, 0.2);
  opacity: 1;
  transition:
    width 200ms ease 0s,
    height 200ms ease 0s,
    max-height 200ms ease 0s,
    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s,
    opacity 83ms ease-out 0s;
  pointer-events: all;
}

.erxes-messenger-shown:after {
  opacity: 0.9 !important;
  right: -20px !important;
  bottom: -20px !important;
}

.erxes-messenger-shown.small {
  max-height: 310px;
}

.erxes-messenger-shown > iframe,
.erxes-notifier-shown > iframe {
  height: 100% !important;
  max-width: none;
}

.erxes-notifier-shown {
  width: 370px;
  height: 230px;
}

.erxes-notifier-shown.fullMessage {
  height: 550px;
  max-height: 100%;
}

@media only screen and (max-width: 420px) {
  #erxes-messenger-container {
    width: 100%;
    max-height: none;
  }

  .erxes-messenger-shown {
    height: 100%;
    width: 100%;
    max-height: none;
    display: block;
    right: 0;
    bottom: 0;
  }

  #erxes-messenger-iframe {
    bottom: 0;
    right: 0;
  }

  body.messenger-widget-shown.widget-mobile {
    overflow: hidden;
    position: absolute;
    height: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./client/messenger/widget/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B;;;;;4BAK0B;EAC1B,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,4CAA4C;EAC5C,UAAU;EACV;;;;;4BAK0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;AACF","sourcesContent":["#erxes-messenger-container {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 2147483647;\n}\n\n#erxes-messenger-iframe {\n  position: absolute !important;\n  border: none;\n  z-index: 2147483647;\n  height: 100%;\n  width: 100%;\n  border-radius: 1rem;\n}\n\n.erxes-launcher {\n  position: absolute;\n  right: 12px;\n  bottom: 12px;\n  border: none;\n  z-index: 2147483649;\n  overflow: hidden;\n  height: 76px;\n  width: 76px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.erxes-messenger-hidden {\n  position: fixed;\n  height: min(720px, 100% - 104px);\n  min-height: 80px;\n  width: 408px;\n  max-height: 720px;\n  border-radius: 1rem;\n  right: 16px;\n  bottom: 92px;\n  transform-origin: right bottom;\n  transition:\n    width 200ms ease 0s,\n    height 200ms ease 0s,\n    max-height 200ms ease 0s,\n    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s,\n    opacity 83ms ease-out 0s;\n  transform: scale(0);\n  opacity: 0;\n  pointer-events: none;\n}\n\n.erxes-messenger-shown {\n  position: fixed;\n  height: min(660px, 100% - 100px);\n  min-height: 80px;\n  /* 400px width of messenger + scrollbar width */\n  width: 408px;\n  max-height: 660px;\n  border-radius: 1rem;\n  right: 16px;\n  bottom: 92px;\n  transform-origin: right bottom;\n  box-shadow: 0 2px 8px 1px rgba(0, 0, 0, 0.2);\n  opacity: 1;\n  transition:\n    width 200ms ease 0s,\n    height 200ms ease 0s,\n    max-height 200ms ease 0s,\n    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s,\n    opacity 83ms ease-out 0s;\n  pointer-events: all;\n}\n\n.erxes-messenger-shown:after {\n  opacity: 0.9 !important;\n  right: -20px !important;\n  bottom: -20px !important;\n}\n\n.erxes-messenger-shown.small {\n  max-height: 310px;\n}\n\n.erxes-messenger-shown > iframe,\n.erxes-notifier-shown > iframe {\n  height: 100% !important;\n  max-width: none;\n}\n\n.erxes-notifier-shown {\n  width: 370px;\n  height: 230px;\n}\n\n.erxes-notifier-shown.fullMessage {\n  height: 550px;\n  max-height: 100%;\n}\n\n@media only screen and (max-width: 420px) {\n  #erxes-messenger-container {\n    width: 100%;\n    max-height: none;\n  }\n\n  .erxes-messenger-shown {\n    height: 100%;\n    width: 100%;\n    max-height: none;\n    display: block;\n    right: 0;\n    bottom: 0;\n  }\n\n  #erxes-messenger-iframe {\n    bottom: 0;\n    right: 0;\n  }\n\n  body.messenger-widget-shown.widget-mobile {\n    overflow: hidden;\n    position: absolute;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
